import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import {
  ExpenseClaimPaginationList,
  ExpenseClaimType,
} from "../../types/ExpenseClaim";
import { PaginationFilters } from "../../types/Pagination";

export type ResolvedExpenseClaimFilters = PaginationFilters & {
  dossierId: string;
  claimTypes?: ExpenseClaimType[];
  dateFrom?: string;
  dateTo?: string;
};

export const getResolvedExpenseClaims = (
  filters: ResolvedExpenseClaimFilters,
  options: APQueryOptions = {}
) => {
  const { nextPageLink, pageSize, claimTypes, ...otherFilters } = filters;
  const { fetchWithAuth } = useApi();
  const { isQueryEnabled } = useAPQuery();

  return useQuery({
    queryKey: ["resolvedExpenseClaims", filters],
    queryFn: (): Promise<ExpenseClaimPaginationList> => {
      return fetchWithAuth<ExpenseClaimPaginationList>(
        "getResolvedExpenseClaims",
        filters.dossierId,
        {
          queryParams: {
            ...otherFilters,
            nextPage: nextPageLink ?? undefined,
            pageSize: pageSize ? `${pageSize}` : undefined,
            claimTypes: claimTypes ? claimTypes.join(",") : undefined,
          },
        }
      );
    },
    enabled: isQueryEnabled(options),
  });
};
